import { useMemo } from 'react';
import { useAppSelector } from '@/core/global-store';

/** Platform owner — manages subscriptions across all tenants. */
export function useIsOwner(): boolean {
    const me = useAppSelector((s) => s.auth.me?.data);

    return useMemo(() => {
        if (!me) return false;
        if (me.role === 'owner') return true;
        const roles = me.roles as string[] | undefined;
        return Array.isArray(roles) && roles.some((r) => r === 'owner');
    }, [me]);
}
